import {
  getCookieId,
  setCookieId,
  removeCookieId,
  removeSession,
  getSession,
  getVerify,
  getVerifyInfo,
  getOpenId,
  setSession
} from './cookie';
import {interact} from 'fire-wind-water';
import {userService} from '../services/user';
import {Observable, Subject} from 'rxjs';
import {auth} from './auth';
import {common} from './common';
import {data} from './data';
import {$module} from '../conf/module';

class User {
  globalUserId: string = getCookieId();
  session: string;
  memberId: string;
  name: string;
  unique: string;
  uniqueType: string;
  token: any;
  tokenInfo: any;
  openId: any;

  status: { [label: string]: string | number };
  formData: any[] = [];
  wxInfo: any = {};
  wxQrCode: any = {};

  constructor() {
  }

  getIP(): Observable<any> {
    const $s = new Subject<any>();
    const info = {
      clientBrand: interact.browseInfo.browser,
      clientIP: '127.0.0.1',
      clientType: interact.browseInfo.browser,
      clientVersion: interact.browseInfo.os
    };
    userService.getIP().then(res => {
      info.clientIP = res.returnCitySN?.cip || '127.0.0.1';
      common.clientIP = info.clientIP;
      $s.next(info);
      $s.complete();
    });
    return $s;
  }

  getId(): Promise<any> {
    return new Promise(resolve => {
      if (!this.globalUserId) {
        this.getIP().subscribe(result => {
          data.getId(result).subscribe(res => {
            if (res) {
              this.globalUserId = res;
              setCookieId(this.globalUserId);
            }
            resolve(this.globalUserId);
          });
        });
      } else {
        resolve(this.globalUserId);
      }
    });
  }

  async updateCookieId() {
    removeCookieId();
    this.globalUserId = null;
    await this.getId();
    return new Promise(resolve => {
      resolve(this.globalUserId);
    });
  }

  async getAsyncInfo(): Promise<any> {
    await this.checkSess();
    await auth.init();
    this.updateUser();
    return new Promise(resolve => {
      resolve(null);
    });
  }

  async isAuth(id): Promise<any> {
    if (id && id !== '0') {
      if (!auth.weChatId || auth.weChatId === '0') {
        auth.weChatId = id;
        await auth.init();
        this.updateUser();
        $module.next({type: 'user-change', data: this.wxInfo});
      }
    }
    return new Promise(resolve => {
      resolve(null);
    });
  }

  getOpenId() {
    const info = {
      weChatId: auth.weChatId,
      openId: this.openId,
      schemaId: common.schemaId
    };
    return new Promise(resolve => {
      data.getByOpenId(info).subscribe(data => {
        if (data) {
          this.updateWxInfo(data);
          resolve(data);
        } else {
          resolve(null);
        }
      });
    });
  }

  updateWxInfo(data) {
    this.wxInfo = data;
    if (this.wxInfo.memberId && this.wxInfo.session) {
      const os = {
        name: this.wxInfo.name,
        memberId: this.wxInfo.memberId,
        unique: this.wxInfo.unique,
        uniqueType: this.wxInfo.uniqueType,
        session: this.wxInfo.session
      };
      setSession(os);
      this.updateSession();
    }
    $module.next({type: 'user-change', data: this.wxInfo});
  }

  updateUser() {
    const verify = getVerify(auth.weChatId);
    const verifyInfo = getVerifyInfo(auth.weChatId);
    const openId = getOpenId(auth.weChatId);
    if (verify) {
      this.token = verify;
    }
    if (verify) {
      this.tokenInfo = verifyInfo;
    }
    if (openId) {
      this.openId = openId;
    }
    this.updateSession();
  }

  updateSession() {
    const sess = getSession();
    this.session = sess?.session || '';
    this.memberId = sess?.memberId || '';
    this.name = sess?.name || '';
    this.unique = sess?.unique || '';
    this.uniqueType = sess?.uniqueType || '';
  }

  updateStatus(status, formData): void {
    this.status = status;
    this.formData = formData;
    $module.next({type: 'user-change', data: {status: this.status, formData: this.formData}});
  }

  checkSess(): Promise<any> {
    const sess = getSession();
    return new Promise(resolve => {
      if (sess) {
        this.session = sess.session;
        this.memberId = sess.memberId;
        const info = {
          globalUserId: this.globalUserId,
          sess: this.session
        };
        data.checkSess(info).subscribe(res => {
          if (!res) {
            removeSession();
            this.session = '';
            this.memberId = '';
          }
          resolve(null);
        });
      } else {
        resolve(null);
      }
    });
  }
}

export {
  User
};

export const user = new User();